// 需要引入crypto-js库
// <script src="https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js"></script>
import CryptoJS from 'crypto-js';

class PasswordEncryptor {

    /**
     * 使用用户名和验证码加密密码
     * @param {string} originalPassword 原始密码
     * @param {string} username 用户名
     * @param {string} verificationCode 验证码
     * @returns {string} Base64编码的加密结果
     */
    static encryptPassword(originalPassword, username, verificationCode) {
        try {
            // 1. 组合基础密钥
            const baseKey = username + ':' + verificationCode;

            // 2. 生成随机盐和IV（增加安全性）
            const salt = CryptoJS.lib.WordArray.random(16); // 16字节盐
            const iv = CryptoJS.lib.WordArray.random(16);   // 16字节IV

            // 3. 使用PBKDF2从基础密钥派生加密密钥
            const derivedKey = CryptoJS.PBKDF2(baseKey, salt, {
                keySize: 256 / 32,    // 256位密钥
                iterations: 10000,    // 迭代次数
                hasher: CryptoJS.algo.SHA256
            });

            // 4. 使用AES加密原始密码
            const encrypted = CryptoJS.AES.encrypt(originalPassword, derivedKey, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

            // 5. 组合: 盐 + IV + 加密数据
            const combined = salt.concat(iv).concat(encrypted.ciphertext);

            // 6. 返回Base64编码
            return combined.toString(CryptoJS.enc.Base64);

        } catch (error) {
            console.error('加密错误:', error);
            throw new Error('密码加密失败');
        }
    }

    /**
     * 验证加密数据格式
     */
    static validateEncryptedData(encryptedData) {
        try {
            const bytes = CryptoJS.enc.Base64.parse(encryptedData);
            return bytes.words.length >= 12; // 至少要有盐+IV+一些数据
        } catch (e) {
            return false;
        }
    }
}

export default PasswordEncryptor;

// testEncryption();
